/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type AutoCompleteData = Record<
  string,
  {
    query: Record<string, string>[];
  }
>;

export interface CorpusTextHTML {
  id?: string;
  utterances?: CorpusTextUtterances[];
}

export interface CorpusTextUtterances {
  id?: string;
  audio?: string;
  content?: string;
}

export interface CorpusText {
  doc?: {
    "@id": string;
    listPrefixDef: PrefixDef[];
    standOff: string;
    divs: Div[];
  };
}

export interface Div {
  /** @pattern ^(#[^\s]*-audio-(public|master)\s*)+$ */
  "@corresp"?: string;
  /** @pattern ^[^#][^\s]* */
  "@id": string;
  u?: U;
  us?: U[];
  Translation_spanGrp?: TranslationSpanGrp;
  /** Used in search hits to reference the document the hits are from */
  "@docRef"?: string;
  /** Used in search results to return the IDs of the tokens that matched the search */
  hits?: string[];
}

export interface U {
  "@lang": string;
  /** @pattern ^#T */
  "@start": string;
  /** @format uri */
  "@who": string;
  /** @pattern ^#T */
  "@end": string;
  "@id": string;
  $$: MixedUtteranceContent;
}

export type MixedUtteranceContent = {
  w?: W;
  pc?: Pc;
  milestone?: Milestone;
  gap?: Gap;
  seg?: Seg;
  vocal?: Vocal;
}[];

export interface W {
  /**
   * @format uri
   * @pattern ^dict:
   */
  "@lemmaRef"?: string;
  subc?: "collectiveNoun" | "pluralNoun" | "toponym";
  derivedVerbClass?: "I" | "II" | "III" | "IV" | "VIII";
  inflectionType?: "I" | "V";
  /** @pattern ^rend: */
  "@rendition"?: "rend:dashAfter" | "rend:ellipsisAfter" | "rend:withBowBelow";
  "@join"?: "right" | "left";
  root?: string;
  /** @uniqueItems true */
  roots?: string[];
  synRoot?: string;
  /** @uniqueItems true */
  synRoots?: string[];
  diaRoot?: string;
  diaRoots?: string[];
  person?: "1" | "2" | "3";
  "@type"?: "truncated";
  $: string;
  /** @pattern -x-shawi-vicav$ */
  "@lang"?: string;
  number?: "plural" | "singular";
  "@msd"?: string;
  degree?: "elative";
  pos?:
    | "article"
    | "complementizerParticle"
    | "interrogative"
    | "negationParticle"
    | "numeral"
    | "particle"
    | "preposition"
    | "verb";
  /** @pattern ine$ */
  gender?: "feminine" | "masculine";
  "@id": string;
}

export interface Pc {
  "@join"?: "right" | "left";
  $: string;
  "@id": string;
}

export interface Gap {
  "@rendition": "rend:ellipsisInSquareBrackets";
}

export interface Milestone {
  "@unit"?: string;
  "@rendition"?: "rend:ellipses";
}

export interface Seg {
  "@lang"?: "ar-acm-x-shawi-vicav";
  /**
   * @format uri
   * @pattern ^dict:
   */
  "@lemmaRef"?: string;
  "@msd"?: "coll.";
  root?: string;
  synRoot?: string;
  diaRoot?: string;
  $$: MixedUtteranceContent;
  "@id": string;
  pos?: "adverb" | "conjunction" | "noun" | "preposition" | "verb";
}

export interface Vocal {
  "@who": string;
  desc: XmlTextNode;
}

export interface TranslationSpanGrp {
  span: {
    "@lang": string;
    /** @pattern ^# */
    "@target": string;
    $: string;
    "@id": string;
  };
  "@type": "Translation";
}

export interface CorpusSearch {
  query?: string;
  hits?: {
    "@page": number;
    "@pageSize": number;
    "@count": number;
    listPrefixDef?: PrefixDef[];
    divs?: Div[];
    div?: Div;
  };
}

export interface CorpusSearchHTML {
  "@page"?: number;
  "@pageSize"?: number;
  "@count"?: number;
  query?: string;
  hits?: CorpusSearchHits[];
}

export interface CorpusSearchHits {
  u?: string;
  docHits?: string[];
  doc?: string;
  content?: {
    left?: string;
    kwic?: string;
    right?: string;
  };
}

export interface ProjectConfig {
  projectConfig?: ProjectConfigType;
  /**
   * The current ETag/Hash of this JSON object.
   * @minLength 32
   * @maxLength 32
   */
  ETag?: string;
  /** Time needed to create this JSON object on the server. */
  took?: string;
}

export interface ProjectConfigType {
  /** Whether this JSON was generated on demand or fetched from a cache. */
  cached?: boolean;
  /** The base URI used in this project config */
  baseURIPublic?: string;
  title?: string;
  logo?: LogoType;
  editors?: {
    given: string;
    family: string;
  }[];
  /**
   * @maxItems 3
   * @minItems 3
   * @uniqueItems true
   */
  pubDate?: any[];
  /** The URL/path of the 'needle' to be used on the maps */
  icon?: string;
  /** Settings for the map displayed initially */
  map?: {
    center: {
      lng: number;
      lat: number;
    };
    zoom: number;
  };
  param?: ParamType;
  /** @minItems 0 */
  panel?: ItemType[];
  menu?: MenuType;
  /** Settings for the two main background colors in the main UI. */
  styleSettings?: {
    colors: {
      /**
       * Background color for the menu
       * @minLength 7
       * @maxLength 7
       */
      nav: string;
      /**
       * Background color for the (map) controls bar
       * @minLength 7
       * @maxLength 7
       */
      subNav: string;
      /** Background color for the menu and other primary elements as hsla expression */
      primary: string;
      /** Background color for the (map) controls bar and other secondary elements as hsla expression */
      secondary: string;
    };
  } | null;
  /** The host the NoSkE engine for this instance of the interface runs on if any (Shawi interface) */
  noskeHost?: string | null;
  /**
   * List of cql attributes that are hidden in the corpus query widget
   * @example ["wid","decomp"]
   */
  cqlIgnoreAttributes?: string[] | null;
  commentOptions?: {
    text: string;
    value: string;
  }[];
  sampleTextSentences?: string;
  /** A list of special transliteration characters usually not found on a keyboard to display on input boxes (specific to projects as dialect requirements can vary). */
  specialCharacters?: SpecialCharacters;
  /** A CSS snippet that should be loaded to customize the colors for a particular instance (Shawi, tunocent) */
  style?: string | null;
  staticData?: {
    geo?: FeatureCollection[];
    /**
     * This does not prescribe any JSON shape. E. g. a malformed guided tour JSON is an object.
     * You have to verify any part of this array independently!
     */
    table?: (Biblio | Geo | TeiCorpus | GuidedTourSteps | object | any[])[];
  } | null;
  /** The institutions that funded this project */
  funders?: {
    /** An ID of a logo image contained in the frontend repo or an https URL pointing to a logo image. */
    logoID: string;
    /** The prescribed attribution text of this funder */
    text: string;
    /** The prescribed URI of this funder (most probably a https://doi.org URI). */
    funderLink: string;
  }[];
  /** The partner institutions */
  partners?: {
    /** An ID of a logo image contained in the frontend repo or an https URL pointing to a logo image. */
    logoID: string;
    /** Attribution of our partner */
    text: string;
    /** A URI to a page at our partner instituion. Can be absent. */
    partnerLink: string;
  }[];
  version?: {
    /** The git hash or version string of the backend code */
    backend?: string;
    /** The git hash or version string of the data this backend serves */
    data?: string;
  };
}

export interface LogoType {
  img?: string;
  string?: string;
}

export type ParamType = string[];

export enum MarkersType {
  Data = "data",
  Sample = "sample",
  Bibl = "bibl",
  Profile = "profile",
  Dict = "dict",
  Feature = "feature",
}

export interface ItemTypeCommon {
  id?: string;
  target?: string;
  title?: string;
  type: "panel" | "item" | "separator" | "dropdown";
  targetType?:
    | "WMap"
    | "DictQuery"
    | "CrossDictQuery"
    | "BiblioQuery"
    | "Text"
    | "SampleText"
    | "DataList"
    | "CorpusQuery"
    | "CorpusText"
    | "Profile"
    | "Feature"
    | "BiblioEntries"
    | "ListMap"
    | "ExploreSamplesForm"
    | "ExploreSamples"
    | "DataTable"
    | "FeatureDescriptionList";
  label?: string;
  class?: "active";
  params?: object;
}

export type ItemType =
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "WMap";
      label?: string;
      class?: "active";
      params: GeoTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "Text";
      label?: string;
      class?: "active";
      params: TextTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "SampleText";
      label?: string;
      class?: "active";
      params: TextTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "Profile";
      label?: string;
      class?: "active";
      params: TextTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "Feature";
      label?: string;
      class?: "active";
      params: TextTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "CorpusText";
      label?: string;
      class?: "active";
      params: TextTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "BiblioEntries";
      label?: string;
      class?: "active";
      params: BiblioEntriesTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "BiblioQuery";
      label?: string;
      class?: "active";
      params: BiblioQueryTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "DictQuery";
      label?: string;
      class?: "active";
      params: DictQueryTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "CrossDictQuery";
      label?: string;
      class?: "active";
      params: CrossDictQueryTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "CorpusQuery";
      label?: string;
      class?: "active";
      params: CorpusQueryTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "DataList";
      label?: string;
      class?: "active";
      params: DataListTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "DataTable";
      label?: string;
      class?: "active";
      params: DataTableTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "ExploreSamplesForm";
      label?: string;
      class?: "active";
      params: ExploreSamplesFormTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "ExploreSamples";
      label?: string;
      class?: "active";
      params: ExploreSamplesTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "ListMap";
      label?: string;
      class?: "active";
      params: ListMapTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "item";
      targetType: "FeatureDescriptionList";
      label?: string;
      class?: "active";
      params: FeatureDescriptionListTargetTypeParameters;
    })
  | (ItemTypeCommon & {
      id?: string;
      target?: string;
      title?: string;
      type: "panel" | "separator" | "dropdown";
      targetType?: string;
      label?: string;
      class?: "active";
      params?: object;
    });

export interface GeoTargetTypeParameters {
  endpoint:
    | "bibl_markers_tei"
    | "data_markers"
    | "dict_markers"
    | "feature_markers"
    | "profile_markers"
    | "sample_markers"
    | "compare_markers";
  queryString: string;
  queryParams?: {
    type?: string;
    features?: string;
    ids?: string;
    translation?: string;
    comment?: string;
    word?: string;
  };
  scope?: ("reg" | "geo" | "diaGroup")[];
  xslt?: string;
  title?: string;
  hideDefaultLayers?: boolean;
  showCitation?: boolean;
  textId?: string;
  teiSource?: string;
}

export interface TextTargetTypeParameters {
  textId: string;
  teiSource?: string;
  queryString?: string;
  filterListBy?: {
    key: string;
    value: string;
  };
  dataTypes?: ("CorpusText" | "Feature" | "Profile" | "SampleText")[];
  xslt?: string;
  hits?: string;
  u?: string;
  showCitation?: boolean;
}

export interface BiblioEntriesTargetTypeParameters {
  queryString: string;
  xslt?: string;
  showMap?: boolean;
  isQueryVisible?: boolean;
  showCitation?: boolean;
  textId?: string;
  teiSource?: string;
}

export interface BiblioQueryTargetTypeParameters {
  textId: string;
  teiSource?: string;
  queryString?: string;
  xslt?: string;
  showMap?: boolean;
  isQueryVisible?: boolean;
  showCitation?: boolean;
}

export interface DictQueryTargetTypeParameters {
  textId: string;
  teiSource?: string;
  queryString: string;
  queryParams?: {
    q?: string;
    page?: number;
    pageSize?: number;
    id?: string;
    ids?: string;
    sort?: string;
    altLemma?: string;
    format?: string;
  };
  queryTemplateTextInput?: string;
  queryTemplate?: string;
  isTextInputManual?: boolean;
  isQueryVisible?: boolean;
  showCitation?: boolean;
}

export interface CrossDictQueryTargetTypeParameters {
  textId: string;
  teiSource?: string;
  queryString?: string;
  showCitation?: boolean;
}

export interface CorpusQueryTargetTypeParameters {
  textId: string;
  teiSource?: string;
  queryString?: string;
  mode?: "tag" | "text";
  showCitation?: boolean;
}

export interface DataListTargetTypeParameters {
  dataTypes: ("CorpusText" | "Feature" | "Profile" | "SampleText")[];
  filterListBy?: {
    key: string;
    value: string;
  };
  listState?: {
    sortMode?: "hit-count" | "alphabetical";
    globalFilter?: string;
    facets?: Record<string, string[]>;
  };
  mapEnabled?: boolean;
  mapSyncId?: string;
  textId?: string;
  teiSource?: string;
  showCitation?: boolean;
}

export interface DataTableTargetTypeParameters {
  dataTypes: ("CorpusText" | "Feature" | "Profile" | "SampleText")[];
  filters?: {
    key: string;
    value: string;
  }[];
  textId?: string;
  teiSource?: string;
  showCitation?: boolean;
}

export interface ExploreSamplesFormTargetTypeParameters {
  dataTypes: ("CorpusText" | "Feature" | "Profile" | "SampleText")[];
  textId?: string;
  teiSource?: string;
  showCitation?: boolean;
}

export interface ExploreSamplesTargetTypeParameters {
  dataType: "SampleText" | "Feature";
  ids?: string;
  word?: string;
  person?: string;
  translation?: string;
  comment?: string;
  features?: string;
  page?: number;
  region?: string;
  settlement?: string;
  textId?: string;
  showCitation?: boolean;
}

export interface ListMapTargetTypeParameters {
  queryString?: string;
  featureValueGroups?: {
    columnId?: string;
    label?: string;
    values?: string[];
  }[];
  globalFilter?: string;
  textId: string;
  teiSource?: string;
  showCitation?: boolean;
}

export interface FeatureDescriptionListTargetTypeParameters {
  taxonomyPath?: string;
  globalFilter?: string;
  textId: string;
  teiSource?: string;
  showCitation?: boolean;
}

export interface MainItemType {
  id: string;
  target: string;
  title: string;
  item: ItemType[];
  type: "dropdown";
}

export interface MenuType {
  main?: MainItemType[];
  subnav?: ItemType[];
}

/** Biblio */
export interface Biblio {
  "@id": string;
  teiHeader: TeiHeader;
  text: {
    front?: object;
    body: ListBiblBody;
    back?: object;
  };
}

/** Geo */
export interface Geo {
  "@id": string;
  teiHeader: TeiHeader;
  text: {
    front?: object;
    body: ListPlaceBody;
    back?: object;
  };
}

/** TeiHeader */
export interface TeiHeader {
  fileDesc: FileDesc;
  profileDesc?: ProfileDesc;
  encodingDesc?: EncodingDesc;
  revisionDesc?: RevisionDesc;
}

/** FileDesc */
export interface FileDesc {
  titleStmt: TitleStmt;
  publicationStmt: PublicationStmt;
  sourceDesc: SourceDesc;
  notesStmt?: NotesStmt;
}

export interface ProfileDesc {
  settingDesc?: SettingDesc;
  textClass?: {
    catRefs: {
      /** @format uri */
      "@target": string;
      "@scheme"?: string;
    }[];
    keywords?: {
      "@scheme"?: string;
      term?: XmlTextNode;
    };
  };
  particDesc?: {
    p?: P;
    person?: Person;
    listPerson?: Person[];
  };
  langUsage?: {
    language?: {
      "@role"?: string;
      "@ident"?: string;
      name?: {
        "@type"?: string;
        $?: string;
      };
      settingDesc?: SettingDesc;
      date?: {
        "@type"?: string;
        note?: {
          $?: string;
        };
      };
      personGrp?: {
        "@role"?: string;
        "@corresp"?: string;
      };
      channel?: {
        "@mode"?: string;
        $?: string;
      };
    };
    [key: string]: any;
  };
}

export interface EncodingDesc {
  tagsDecl?: {
    "@partial": string;
    renditions: {
      "@scheme": "css";
      $: string;
      "@id": string;
    }[];
  };
  classDecl?: {
    taxonomies: Taxonomy[];
  };
  listPrefixDef?: {
    "@matchPattern": string;
    "@ident": string;
    "@replacementPattern": string;
    p?: {
      ref?: {
        "@target": string;
        $: string;
      };
      code?: {
        $: string;
      };
      gi?: {
        $: string;
      };
      att?: {
        $: string;
      };
      $: string;
    };
  }[];
  projectDesc?: {
    ab?: XmlTextNode;
  };
}

export interface Taxonomy {
  categories: Category[];
}

export interface Category {
  "@id": string;
  "@n"?: string;
  "@corresp"?: string;
  catDesc: {
    "@lang"?: string;
    name?: {
      "@lang"?: string;
      $: string;
    };
    term?: {
      $: string;
    };
    $?: string;
  };
  category?: Category;
  categories?: Category[];
}

export interface RevisionDesc {
  changes?: Change[];
  change?: Change;
}

export interface Change {
  "@n"?: string;
  "@who"?: string;
  "@when": string;
  $?: string;
}

export interface TeiCorpus {
  "@id"?: string;
  "@document-uri"?: string;
  teiHeader?: TeiHeader;
  TEIs?: TEI[];
  standOff?: {
    listPerson: ListPersonStandOff[];
  };
}

export interface TEI {
  "@id"?: string;
  "@document-uri"?: string;
  "@type"?: "recording";
  "@corresp"?: string;
  "@hasTEIw"?: "true";
  "@space"?: "preserve";
  teiHeader?: TeiHeader;
  standOff?: object;
}

export interface ListPersonStandOff {
  persName: {
    surname?: {
      $?: string;
    };
    forename?: {
      $: string;
    };
    $?: string;
  };
  note?: {
    $?: string;
  };
  idno?: {
    "@subtype"?: "ORCID";
    /**
     * @minLength 3
     * @maxLength 5
     */
    "@type": string;
    /**
     * @minLength 17
     * @maxLength 37
     */
    $: string;
  };
  ptrs: string[];
  /**
   * @minLength 2
   * @maxLength 7
   */
  "@id": string;
  state?: {
    desc: {
      $?: string;
    };
    "@type": "projectRole";
  };
  affiliation?: {
    $?: string;
  };
}

/** XmlTextNode */
export interface XmlTextNode {
  "@lang"?: string;
  $: string;
}

/** XmlTextNodeOrEmpty */
export interface XmlTextNodeOrEmpty {
  $?: string;
}

export type XmlMixedContent = (XmlTextNode | Att | Code | Gi | Ref)[];

/** TitleStmt */
export interface TitleStmt {
  authors?: {
    $: string;
    "@id"?: string;
  }[];
  title?: {
    $: string;
  };
  respStmts?: RespStmt[];
  funder?: {
    orgName: {
      $: string;
      /**
       * @format uri
       * @pattern ^https://ror\.org/0
       */
      "@ref": string;
    };
    idno: {
      "@type": string;
      $: string;
    };
    /** @pattern ^Funded by the  */
    $: string;
  };
  titles?: {
    "@level"?: string;
    "@type"?: string;
    $: string;
  }[];
  editor?: {
    $: string;
    "@role": string;
    "@id": string;
  };
}

/** PublicationStmt */
export interface PublicationStmt {
  teiSource_idno?: {
    "@type": "teiSource";
    /**
     * @format uri
     * @pattern ^https://github\.com/.*\.xml$
     */
    $: string;
  };
  availability?: {
    /** @pattern e$ */
    "@default"?: "false" | "true";
    /** @pattern ^# */
    "@corresp"?: string;
    licence?: {
      /** @pattern ^http */
      "@target": string;
      $?: string;
    };
    "@status": "free" | "restricted";
    "@id"?: string;
    /**
     * @format uri
     * @pattern ^[^:]+:
     */
    "@sameAs"?: string;
    p?: {
      ref?: {
        /** @format uri */
        "@target": string;
        "@type": string;
      };
      /** @pattern \.$ */
      $?: string;
      "@id"?: string;
    };
  };
  pubPlace?: {
    $: string;
  };
  date?: {
    "@when"?: string;
    $?: string;
  };
  idno?: {
    /**
     * @minLength 13
     * @maxLength 16
     * @pattern CorpusID$
     */
    "@type"?: string;
    $: string;
  };
  p?: {
    $: string;
  };
  address?: {
    $: string;
  }[];
  distributor?: {
    $: string;
    /** @format uri */
    "@ref": string;
  };
  publishers: {
    orgName?: {
      $: string;
    };
    date?: {
      $: string;
    };
    $?: string;
    /** @pattern ^https://ror\.org/03 */
    "@ref"?: string;
  }[];
}

export interface SourceDesc {
  biblStruct?: BiblStruct;
  p?: P;
  recordingStmt?: RecordingStmt;
}

export interface NotesStmt {
  note?: {
    "@type"?: string;
    $?: string;
  };
}

/** ListBiblBody */
export interface ListBiblBody {
  listBibl: ListBibl;
}

/** ListBibl */
export interface ListBibl {
  biblStructs: (BiblStruct | Bibl)[];
}

/** BiblStruct */
export interface BiblStruct {
  "@type"?: BiblStructType;
  "@id"?: string;
  /** @format uri */
  "@corresp"?: string;
  "@n"?: string;
  monogr?: Monogr;
  note?: Note;
  analytic?: Analytic;
  series?: Series;
  notes?: Note[];
  subject_ref?: SubjectRef;
  subject_refs?: SubjectRef[];
}

export interface Bibl {
  biblScope: {
    $: string;
    "@unit": string;
  };
  title: {
    "@ref": string;
  };
  "@id": string;
}

/** Analytic */
export interface Analytic {
  title?: Title;
  author?: Author;
  authors?: Author[];
  idno?: Idno;
  titles?: Title[];
}

/** Author */
export interface Author {
  "@id"?: string;
  forename?: XmlTextNode;
  surname?: XmlTextNode;
  name?: XmlTextNode;
}

/** Reference to an Author */
export interface AuthorRef {
  /** @pattern ^[^:]+: */
  "@ref": string;
  forename?: XmlTextNode;
  surname?: XmlTextNode;
}

/** Title */
export interface Title {
  "@level"?: Level;
  $?: string;
  "@type"?: TitleType;
}

/** Monogr */
export interface Monogr {
  title?: Title;
  author?: Author;
  imprint: Imprint;
  idno?: Idno;
  editors?: Author[];
  authors?: Author[];
  titles?: Title[];
  editor?: Author;
  extent?: XmlTextNode;
  meeting?: Meeting;
  respStmt?: RespStmt;
  respStmts?: RespStmt[];
  edition?: XmlTextNode;
  idnos?: Idno[];
}

/** Idno */
export interface Idno {
  "@type": IdnoType;
  $: string;
}

/** Imprint */
export interface Imprint {
  date: XmlTextNode;
  pubPlace?: XmlTextNode;
  biblScopes?: BiblScope[];
  publisher?: XmlTextNode;
  note?: Idno;
  biblScope?: BiblScope;
  notes?: Idno[];
}

/** BiblScope */
export interface BiblScope {
  "@unit": Unit;
  $: string;
}

export type Meeting =
  | {
      name: XmlTextNode;
      date: XmlTextNode;
      placeName: XmlTextNode;
    }
  | XmlTextNode;

/** ListBiblBody */
export interface ListPlaceBody {
  listPlace: ListPlace;
}

export type ListPlace = GeoPlace[];

export interface GeoPlace {
  "@type": "geo" | "reg" | "diaGroup";
  "@id": string;
  location: {
    country?: {
      "@key": string;
      $: string;
    };
    region?: XmlTextNode;
    /**
     * @maxItems 2
     * @minItems 2
     */
    geos: (
      | {
          "@decls": "#dms";
          $: string;
        }
      | {
          "@decls": "#dd";
          $: string;
        }
    )[];
  };
  prefLabel_placeName: {
    "@type": "prefLabel";
    $?: string;
  };
  standard_placeName?: {
    "@lang": string;
    "@type": "standard";
    $: string;
  };
  note?: XmlTextNode;
  notes?: XmlTextNode[];
  geoNames_idno?: {
    "@type": "geoNames";
    $: string;
  };
  local_placeName?: {
    "@lang": string;
    "@type": "local";
    $: string;
  };
  referencedBy?: {
    /** The data type the reference was found in. */
    source: string;
    ids: {
      /** The reference that was found. geo: + id. */
      reference: string;
      /** The next item in the XML above that addressable by an ID. */
      id: string;
    }[];
  }[];
  [key: string]: any;
}

/** RespStmt */
export interface RespStmt {
  name?: {
    $: string;
    "@id"?: string;
  };
  persName?: Author | AuthorRef;
  resp: {
    $?: Responsibility;
  };
}

export enum Responsibility {
  Dictionary = "Dictionary",
  ELAN = "ELAN",
  NationalCooperationPartner = "National Cooperation Partner",
  PrincipalInvestigator = "Principal Investigator",
  DHConsulting = "DH consulting",
  ResearchDataEngineer = "Research Data Engineer",
  ResearchSoftwareEngineer = "Research Software Engineer",
  TechnicalEditor = "Technical_Editor",
  Transcription = "Transcription",
  Creator = "Creator",
  Author = "author",
  Contributor = "contributor",
  DataManagementAndConversion = "data management and conversion",
  Recording = "recording",
  Transcription1 = "transcription",
  TranscriptionCheck = "transcription check",
  Translation = "translation",
  TranslationCheck = "translation check",
  Interviewer = "Interviewer",
  Principal = "Principal",
  DataManagement = "data management",
  Principal2 = "principal",
  TechnicalImplementation = "technical implementation",
  TransferToELAN = "transfer to ELAN",
  DocumentPreparation = "document preparation",
  TranscriptionTEITranslation = "Transcription, TEI, Translation",
  TranscriptionELANTEITranslation = "Transcription, ELAN, TEI, Translation",
  RecordingsTranscriptionDictionary = "Recordings, Transcription, Dictionary",
  WithCollaborationOf = "with collaboration of",
}

/** Note */
export interface Note {
  "@type"?: NoteType;
  note?: GeoNote | Note;
  notes?: (GeoNote | Note)[];
  $?: string;
  $$?: Note[];
  p?: P;
  ps?: P[];
  hi?: Hi;
  his?: Hi[];
  div?: Div;
  [key: string]: any;
}

/** GeoNote */
export interface GeoNote {
  "@type": NoteType;
  date?: Date;
  name?: Idno;
  geo?: XmlTextNode;
  $?: string;
  note?: Note;
  "@subtype"?: NoteSubtype;
}

export interface SubjectRef {
  "@type": "subject";
  $: string;
  /** @pattern ^[^:]+: */
  "@target": string;
  "@subtype": "geagraphic" | "concept";
}

/** Hi */
export interface Hi {
  "@style"?: string;
  "@rend"?: Rend;
  $: string;
}

/** Date */
export interface Date {
  "@type": NoteType;
  "@cert": Cert;
  /** @format date */
  "@notBefore-iso": string;
  /** @format date */
  "@notAfter-iso": string;
  $: string;
}

/** Div */
export interface Div {
  /** @format integer */
  "@data-schema-version"?: string;
  p: P;
}

/** P */
export interface P {
  "@id"?: string;
  "@style"?: string;
  $?: string;
  $$?: P[];
  hi?: Hi;
  his?: Hi[];
  ptr?: Ptr;
}

export interface Ptr {
  "@target": string;
  $?: string;
}

/** Series */
export interface Series {
  title: Title;
  biblScope?: BiblScope;
  editor?: Author;
  editors?: Author[];
}

/** BiblStructType */
export enum BiblStructType {
  Thesis = "thesis",
  ConferencePaper = "conferencePaper",
  BookSection = "bookSection",
  Book = "book",
  JournalArticle = "journalArticle",
  EncyclopediaArticle = "encyclopediaArticle",
  Presentation = "presentation",
  Dataset = "dataset",
  Report = "report",
  Manuscript = "manuscript",
  MagazineArticle = "magazineArticle",
  BlogPost = "blogPost",
}

/** IdnoType */
export enum IdnoType {
  DOI = "DOI",
  ISSN = "ISSN",
  ISBN = "ISBN",
  CallNumber = "callNumber",
  ThesisType = "thesisType",
  Url = "url",
  Accessed = "accessed",
  Reg = "reg",
  Geo = "geo",
}

/** Level */
export enum Level {
  A = "a",
  M = "m",
  J = "j",
  S = "s",
}

/** TitleType */
export enum TitleType {
  Short = "short",
  ConferenceName = "conferenceName",
  Alternative = "alternative",
}

/** Unit */
export enum Unit {
  Page = "page",
  Volume = "volume",
  Issue = "issue",
}

/** Rend */
export enum Rend {
  I = "i",
  H2 = "h2",
  B = "b",
}

/** NoteType */
export enum NoteType {
  DataCollection = "dataCollection",
  Tag = "tag",
  Tags = "tags",
  Abstract = "abstract",
  MissingGeoData = "missing_geo_data",
}

/** Cert */
export enum Cert {
  Low = "low",
  Unknown = "unknown",
  High = "high",
}

/** NoteSubtype */
export enum NoteSubtype {
  UnmarkedGeo = "unmarked_geo",
}

/** GeoJSON Feature */
export interface Feature {
  type: "Feature";
  id?: number | string;
  /** Three mutually exclusive shapes: GeoPlace (a gazetteer entry), VarietyFeatureProperties (a place described by feature types) and MarkerProperties (a map marker). */
  properties: GeoPlace | VarietyFeatureProperties | MarkerProperties | null;
  geometry: null | Point;
}

/** Source of a feature value observation */
export interface FeatureValueSource {
  bibl_id?: string;
  link?: string;
  short_cit?: string;
}

/** An attested example of a feature value, keyed by the example text */
export type FeatureValueExample = Record<string, string>;

/** One observation of a feature value in a place */
export interface FeatureValueObservation {
  resp: string;
  variety: string;
  source: FeatureValueSource;
  examples?: FeatureValueExample[];
  source_representations?: string[];
  tribe?: string[];
  religion?: string[];
  remarks?: string[];
  exceptions?: string[];
  constraints?: string[];
  ageGroup?: string[];
  gender?: string[];
  firstLanguage?: string[];
}

/** The observations of one feature value, keyed by the feature value */
export type FeatureValues = Record<string, FeatureValueObservation[]>;

/** Properties of a place that is described by feature types */
export interface VarietyFeatureProperties {
  name: string;
  country: string;
  alternateNames: {
    lang?: string;
    name: string;
  }[];
}

/** GeoJSon Feature collection */
export interface FeatureCollection {
  type: "FeatureCollection";
  features: Feature[];
  /**
   * This does not prescribe any JSON shape. E. g. a malformed gazetteer marker JSON is an object.
   * You have to verify any object here independently!
   */
  properties?: ColumnHeadings | GazetteerMarker | object;
}

export interface ColumnHeadings {
  column_headings?: {
    Reference?: string;
    Heading?: string;
  }[];
}

export interface GazetteerMarker {
  description?: "GEOJSON of the VICAV gazetteer";
}

/** Properties of a marker which should be displayed */
export interface MarkerProperties {
  type: "geo" | "reg";
  name?: string;
  label: string;
  alt?: string;
  hitCount: number;
  targetType?: string;
  textId?: string;
  queryString?: string;
  params?: {
    dataType?: string;
    features?: string;
    ids?: string;
    translation?: string;
    comment?: string;
    word?: string;
    filters?: {
      key?: string;
      value?: string;
    }[];
  };
}

/** GeoJSON Point */
export interface Point {
  type: "Point";
  /** @minItems 2 */
  coordinates: number[];
  /** @minItems 4 */
  bbox?: number[];
}

export interface PrefixDef {
  /**
   * @minLength 6
   * @maxLength 6
   */
  "@matchPattern": string;
  /**
   * @minLength 3
   * @maxLength 6
   */
  "@ident": string;
  /**
   * @minLength 18
   * @maxLength 98
   */
  "@replacementPattern": string;
  p: {
    $$: XmlMixedContent;
  };
}

export interface Att {
  att?: XmlTextNode;
}

export interface Code {
  code?: XmlTextNode;
}

export interface Gi {
  gi?: XmlTextNode;
}

export type Ref = any;

export interface RecordingStmt {
  "@id"?: string;
  /** @format uri */
  "@sameAs"?: string;
  recording: {
    "@type": "audio";
    "@dur-iso": string;
    respStmt?: RespStmt;
    date?: {
      /** @format date */
      "@when": string;
    };
    media?: {
      "@decls"?: string;
      desc?: {
        $: string;
      };
      "@mimeType": "audio/wma" | "audio/m4a" | "audio/mp3" | "audio/mp4" | "audio/aac" | "audio/ogg" | "audio/wav";
      /** @format uri */
      "@url": string;
      "@type": "distributionFile" | "master" | "fragment";
      "@id"?: string;
    };
    p?: P;
  };
}

export interface SettingDesc {
  /**
   * @format uri
   * @pattern ^[^:]+:
   */
  "@corresp"?: string;
  p?: {
    $: string;
  };
  place?: {
    location?: {
      geo: {
        /** @pattern ^3 */
        $: string;
      };
    };
    placeName?: XmlTextNodeOrEmpty;
    country?: {
      $: string;
    };
    /**
     * @format uri
     * @pattern ^[^:]+:
     */
    "@sameAs"?: string;
    region?: {
      $: string;
    };
    settlement?: {
      name: {
        "@lang": string;
        $: string;
      }[];
    };
  };
  setting?: {
    placeName?: {
      "@sameAs"?: string;
      $?: string;
    };
    additionalProperties?: any;
    p?: XmlTextNode;
  };
  listPlace?: {
    place?: {
      "@sameAs"?: string;
    };
  };
}

export interface Person {
  "@id"?: string;
  /** @format uri */
  "@sameAs"?: string;
  "@age"?: string;
  "@sex"?: "f" | "m" | "missing";
  sex?: {
    $?: "F" | "M" | "D";
  };
  idno?: {
    $: string;
  };
  name?: {
    "@type": "pseudonym";
    $: string;
  };
  birth?: {
    $?: string;
    date?: {
      "@notBefore"?: string;
      "@notAfter"?: string;
      "@when"?: string;
      $?: string;
    };
    placeName?: {
      "@sameAs"?: string;
      $?: string;
    };
    note?: XmlTextNode;
  };
  state?: ConsentState | TribeMembershipState;
  note?: {
    $: string;
  };
  ptrs?: {
    "@target": string;
    "@type": "participantIn" | "participatedIn";
  }[];
  langKnowledge?: {
    langKnown?: object;
  };
  $?: string;
}

export interface ConsentState {
  "@type": "consent";
  label: {
    $: "yes" | "no" | "missing";
  };
}

export interface TribeMembershipState {
  "@type": "tribeMembership";
  desc: {
    orgName: {
      "@type"?: "tribe";
      "@ref"?: string;
      $?: string;
    };
  };
}

/** A RFC 7807 problem report */
export interface RFC7807Problem {
  type: string;
  title: string;
  detail: string;
  instance: string;
  status: string;
  trace?: string;
  "xml:space"?: "preserve" | "default";
}

/** A hyperlink reference */
export interface HALhref {
  href: string;
}

/** Hypermedia Application Language paging links */
export interface HALLinks {
  self: HALhref;
  first?: HALhref;
  last?: HALhref;
}

/** Pointer to next useful URIs */
export interface RestVLEURIs {
  _links: HALLinks;
  _embedded: {
    _: {
      note: string;
      _links: HALLinks;
    }[];
  };
  page_count: string;
  page_size: string;
  total_items: string;
  page: string;
  took: string;
}

export interface RestVLEDicts {
  _links: HALLinks;
  _embedded: {
    dicts: {
      name: string;
      _links: HALLinks;
    }[];
  };
  page_count: string;
  page_size: string;
  total_items: string;
  page: string;
  took: string;
}

export interface RestVLEDictInfo {
  _links: HALLinks;
  _embedded: {
    _: {
      note: string;
      _links: HALLinks;
      /** All available stored queries */
      queryTemplates?: string[];
      /** A list of special transliteration characters usually not found on a keyboard to display on input boxes (specific to projects as dialect requirements can vary). */
      specialCharacters?: SpecialCharacters;
      dbNames?: string[];
    }[];
  };
  page_count: string;
  page_sizes?: string;
  total_items: string;
  page: string;
  took: string;
}

export interface RestVLEEntries {
  _links: HALLinks;
  _embedded: {
    entries: RestVLEEntry[];
  };
  page_count: string;
  page_size: string;
  total_items: string;
  page: string;
  took: string;
}

export type SearchTags = {
  /** Label to dispplay for this item */
  label?: string;
  /** Value to pass to search endpoint */
  value?: string;
}[];

export interface RestVLEEntry {
  /** xml:id of the entry (equals sid for historcal reasons) */
  id: string;
  /** xml:id of the entry */
  sid: string;
  /** String representing the lemma, configurable */
  lemma: string;
  /** Edition status of the entry. should be 'released' for published entries */
  status?: string;
  /** One of 'entry', 'cit', ... */
  type?: "entry" | "example" | "header";
  /** Either the source XML of the entry or rendered as HTML on the server */
  entry?: DictEntry | DictExample | DictHeader | string;
  storedEntryMd5?: string;
  _links: HALLinks;
  took?: string;
}

export interface DictEntry {
  "@lang": string;
  features: DictChange[];
  feature?: DictChange;
  ref?: Ref;
  gramGrp: GramGrp;
  gramGrps?: GramGrp[];
  sense?: Sense;
  /** @minLength 2 */
  senses?: Sense[];
  multiWordUnit_form?: {
    /** @minItems 2 */
    orths?: XmlTextNode[];
    orth?: XmlTextNode;
    "@type": "multiWordUnit";
  };
  workflow_note?: {
    "@type": "workflow";
    $: string;
  };
  note?: XmlTextNode;
  example_cit?: DictExample;
  example_cits?: DictExample[];
  def?: XmlTextNode;
  /** @minItems 2 */
  defs?: XmlTextNode[];
  translation_cit?: TranslationCit;
  translation_cits?: TranslationCit[];
  translationEquivalent_cit?: TranslationEquivalentCit;
  translationEquivalent_cits?: TranslationEquivalentCit[];
  lemma_form: LemmaForm;
  lemmaVariant_forms?: LemmaVariantForm[];
  lemmaVariant_form?: LemmaVariantForm;
  /** @minItems 2 */
  inflected_forms?: InflectedForm[];
  inflected_form?: InflectedForm;
  /** @minItems 2 */
  usgs?: XmlTextNode[];
  geographic_usg?: {
    "@type": "geographic";
    tribe_name?: {
      "@type": "tribe";
      $: string;
    };
    place_name?: {
      "@type": "place";
      $: string;
    };
  };
  etym?:
    | Etym
    | {
        lang?: Lang;
        mentioned?: Mentioned;
        $$?: (
          | XmlTextNode
          | {
              lang: Lang;
            }
          | {
              mentioned: Mentioned;
            }
        )[];
      };
  listBibl?: ListBibl;
  "@id": string;
  related_xr?: ExampleRelatedXr;
  related_xrs?: ExampleRelatedXr[];
}

export interface GramGrp {
  gram?: any;
  root_gram?: {
    "@lang": "ar-Latn";
    "@type": "root";
    $?: string;
  };
  /**
   * @maxItems 2
   * @minItems 2
   */
  root_grams?: {
    "@lang": "ar-Latn" | "ar";
    "@type": "root";
    $: string;
  }[];
  synRoot_gram?: {
    "@lang": string;
    "@type": "synRoot";
    $?: string;
  };
  diaRoot_gram?: {
    "@lang": string;
    "@type": "diaRoot";
    $?: string;
  };
  roots_gram?: {
    "@type": "roots";
    "@lang"?: "ar-Latn";
  } & XmlTextNode;
  number_gram?: {
    "@type": "number";
    $: string;
  };
  pos_gram?: {
    "@type": "pos";
    $: string;
  };
  person_gram?: {
    "@type": "person";
    $: string;
  };
  /** @deprecated */
  subc_gram?: {
    "@type": "subc";
    $: string;
  };
  derivedVerbClass_gram?: {
    "@type": "derivedVerbClass";
    $: string;
  };
  gender_gram?: {
    "@type": "gender";
    $: "feminine" | "feminine/masculine" | "masculine";
  };
  inflectionType_gram?: {
    "@type": "inflectionType";
    $: "diptotic" | "invariable";
  };
  degree_gram?: {
    "@type": "degree";
    $: "elative";
  };
  voice_gram?: {
    "@type": "voice";
    $: "passive";
  };
  msd_gram?: {
    "@type": "msd";
    $: "activeParticiple" | "passiveParticiple";
  };
  constraint_gram?: {
    "@type": "constraint";
    $: string;
  };
  mood_gram?: {
    "@type": "mood";
    $: "imperative";
  };
  morphPattern_gram?: {
    "@lang": string;
    "@type": "morphPattern";
    $?: string;
  };
  socioCultural_usg?: {
    "@type": "socioCultural";
    $: string;
  };
  temporal_usg?: {
    "@type": "temporal";
    $: string;
  };
  /** @deprecated */
  usg_gram?: {
    "@type": "usg";
    $: string;
  };
}

export interface LemmaVariantForm {
  "@type": "lemmaVariant";
  orth: XmlTextNode;
  /** @minItems 2 */
  orths?: XmlTextNode[];
  reg_usg?: {
    "@type": "reg";
    $: string;
  };
}

export interface Sense {
  "@id": string;
  "@ana"?: string;
  domain_usg?: DomainUsg;
  /** @minItems 2 */
  domain_usgs?: DomainUsg[];
  pragmatics_usg?: PragmaticsUsg;
  /** @minItems 2 */
  pragmatics_usgs?: PragmaticsUsg[];
  socioCultural_usg?: {
    "@type": "socioCultural";
    $: "formal" | "high";
  };
  gramGrp?: SenseGramGrp;
  /** @minLength 2 */
  gramGrps?: SenseGramGrp[];
  translationEquivalent_cit?: TranslationEquivalentCit;
  translationEquivalent_cits?: TranslationEquivalentCit[];
  glosses?: XmlTextNode[];
  geographic_usg?: {
    "@type": "geographic";
    $: string;
  };
  def?: object;
  defs?: object[];
  example_cit?: ExampleCit;
  example_cits?: ExampleCit[];
  related_xr?: ExampleRelatedXr;
  related_xrs?: ExampleRelatedXr[];
}

export interface ExampleRelatedXr {
  example_cit: ExampleCit;
  "@type": "related";
  /** A warning message genrated when the @type of the ref and the @type of the @target do not match */
  $?: string;
}

export interface SenseGramGrp {
  constraint_gram?: {
    "@lang"?: any;
    "@type": "constraint";
    $: string;
  };
  valency_gram?: {
    "@type": "valency";
    $: "intransitive" | "transitive";
  };
  government_gram?: {
    "@type": "government";
    $: string;
  };
  construction_grams?: {
    "@lang"?: string;
    oRef_ref?: {
      "@valueDatcat"?: string;
      "@type": "oRef";
    };
    constrPart_seg?: {
      /** @pattern ^# */
      "@valueDatcat"?: string;
      "@type": "constrPart";
      $?: string;
    };
    "@type"?: "construction";
    $?: string;
  }[][];
  collocate_gram?: {
    "@lang"?: any;
    "@type": "collocate";
    $: string;
  };
}

export interface DomainUsg {
  /** @pattern ^#domains\. */
  "@valueDatcat": string;
  "@type": "domain";
  $: string;
}

export interface ExampleCit {
  "@type": "example";
  "@subtype"?: "proverb";
  translation_cit?: TranslationCit;
  /** @minItems 2 */
  translation_cits?: TranslationCit[];
  quote: {
    "@lang": string;
    /** @minLength 6 */
    $?: string;
    /**
     * @maxItems 11
     * @minItems 3
     */
    $$?: {
      "@lang"?: string;
      exPart_seg?: ExpartSeg;
      /** @minItems 2 */
      exPart_segs?: ExpartSeg[];
      $?: string;
    }[];
  };
}

export interface ExpartSeg {
  /** @pattern ^#V */
  "@corresp": string;
  "@type": string;
  $: string;
}

export interface InflectedForm {
  orth?: XmlTextNode;
  /** @minItems 2 */
  orths?: XmlTextNode[];
  "@type": "inflected";
  reg_usg?: {
    "@type": "reg";
    $: string;
  };
  /** @pattern ^# */
  "@ana"?: string;
  geographic_usg?: {
    "@type": "geographic";
    place_name: {
      "@type": "place";
      $: string;
    };
  };
  gramGrp?: GramGrp;
}

export interface Lang {
  $: string;
}

export interface Mentioned {
  $: string;
}

export interface LemmaForm {
  "@type": "lemma";
  "@subtype"?: string;
  "@lang"?: string;
  orth?: XmlTextNode;
  orths?: XmlTextNode[];
  variant_form?: VariantForm;
  /** @minItems 2 */
  variant_forms?: VariantForm[];
  geographic_usg?: {
    "@type": "geographic";
    place_name: {
      "@type": "place";
      $: string;
    };
  };
  gramGrp?: GramGrp;
  workflow_note?: {
    "@type": "workflow";
    $: string;
  };
}

export interface VariantForm {
  orth: XmlTextNode;
  orths?: XmlTextNode[];
  "@type": "variant";
  geographic_usg: {
    "@type": "geographic";
    place_name: {
      "@type": "place";
      $: string;
    };
  };
  gramGrp?: {
    constraint_gram: {
      "@type": "constraint";
      $: string;
    };
  };
}

export interface TranslationCit {
  "@lang"?: string;
  quote: XmlTextNode;
  "@type": "translation";
}

export interface TranslationEquivalentCit {
  "@lang"?: "de" | "en" | "tr" | "fr";
  "@type": "translationEquivalent";
  form: {
    orth: {
      $: string;
    };
  };
  gloss?: {
    $: string;
  };
}

export interface Etym {
  etym?: Etym;
  etymon_cit?: EtymonCit;
  /** @minItems 2 */
  etymon_cits?: EtymonCit[];
}

export interface EtymonCit {
  "@type": "etymon";
  "@cert"?: "medium";
  form: {
    orth: {
      "@lang": string;
      "@cert"?: "unknown";
      $: string;
    };
  };
}

export interface PragmaticsUsg {
  "@lang"?: "en" | "de";
  "@type": "pragmatics";
  $: string;
}

export interface DictChange {
  create?: {
    who: string;
    status: "stub";
    /** @pattern ^\d\d\d\d-\d\d-\d\d$ */
    when?: any;
  };
  change?: {
    who?: string;
    /** @pattern ^\d\d\d\d-\d\d-\d\d$ */
    when?: string;
    status: "draft" | "released" | "stub";
  };
}

export interface DictExample {
  feature?: DictChange;
  features?: DictChange[];
  /** @minItems 2 */
  translation_cits?: TranslationCit[];
  quote: XmlTextNode;
  "@vutlsk"?: string;
  "@type": "example";
  "@subtype"?: string;
  translation_cit?: TranslationCit;
  "@id": string;
}

export interface DictHeader {
  revisionDesc?: object;
  fileDesc?: object;
  "@id"?: "dictHeader";
}

/** A list of special transliteration characters usually not found on a keyboard to display on input boxes (specific to projects as dialect requirements can vary). */
export type SpecialCharacters = {
  /** The character that should be displayed on a button and inserted in the input field unless text exists. Then this is only the character for the input field. */
  value: string;
  /** Optionally a character or an HTML snipet that should be displayed on the button. */
  text?: string;
}[];

/** The tour in presentation order. The component walks the array from index 0; leaving the last step finishes the tour. */
export type GuidedTourSteps = TourStep[];

/** A single stop on the guided tour. */
export interface TourStep {
  /** The element the step points at and cuts out of the overlay. */
  attachTo: StepAttachTo;
  /** The text shown in the step's tooltip. */
  content: StepContent;
  /** Per-step overrides of the wrapper options set on `VOnboardingWrapper`. Note that `hideNextStepDuringHook` and `hideButtons.next` are set by the component itself and are overwritten here. */
  options?: VOnboardingWrapperOptions;
  /**
   * When set, the step does not offer a "Next" button and the tour only advances once the user has clicked something: the element the step is attached to (`true`), or the CSS selector named here — useful when the step highlights a whole panel but hinges on one button inside it.
   * @default false
   */
  requireClick?: boolean | AttachableElement;
  /**
   * How long to wait for the step's element to turn up before giving up on the step, in milliseconds. Raise it where the user has to work through a menu or a dialog first. When the element never appears the step is skipped in the current direction rather than stranding the user.
   * @min 0
   * @default 10000
   */
  waitTimeout?: number;
  /**
   * How long to let the layout settle before the step is positioned, in milliseconds. Raise it for steps that follow an interaction with a lot of reflow behind it.
   * @min 0
   * @default 400
   */
  settleDelay?: number;
}

/** The element the step points at and cuts out of the overlay. */
export interface StepAttachTo {
  /**
   * A CSS selector resolved against the document at the moment the step is entered. `v-onboarding` also accepts a getter function or a Vue `Ref`, but neither survives JSON, so steps defined in this file are limited to selectors.
   *
   * The element does not have to exist yet: the component observes the DOM and waits up to `waitTimeout` for it, which is what lets a step attach to a window or dialog the previous step told the user to open.
   */
  element: AttachableElement;
  /** Classes added to the attached element for the duration of the step. */
  classList?: string[];
}

/** The text shown in the step's tooltip. */
export interface StepContent {
  title: string;
  description?: string;
  /**
   * Render `title` and `description` as HTML rather than as text. Only safe for trusted, hand-authored content.
   * @default false
   */
  html?: boolean;
}

/**
 * A CSS selector resolved against the document at the moment the step is entered. `v-onboarding` also accepts a getter function or a Vue `Ref`, but neither survives JSON, so steps defined in this file are limited to selectors.
 *
 * The element does not have to exist yet: the component observes the DOM and waits up to `waitTimeout` for it, which is what lets a step attach to a window or dialog the previous step told the user to open.
 * @minLength 1
 */
export type AttachableElement = string;

/** Options accepted by `VOnboardingWrapper`, either globally or per step. `popper.modifiers` and `popper.onFirstUpdate` are omitted: both carry functions and cannot be expressed in JSON. */
export interface VOnboardingWrapperOptions {
  /** Popper.js options for placing the tooltip relative to the attached element. */
  popper?: {
    /** Where the tooltip sits relative to the attached element. `auto*` picks the side with the most room. */
    placement?: PopperPlacement;
    /**
     * Positioning strategy. `fixed` helps when an ancestor of the attached element clips or transforms it.
     * @default "absolute"
     */
    strategy?: "absolute" | "fixed";
  };
  /** The dimmed backdrop and the cut-out around the attached element. */
  overlay?: SvgOverlayOptions;
  /** Whether to scroll the attached element into view before the step is shown. */
  scrollToStep?: {
    /** @default true */
    enabled?: boolean;
    /** Passed straight to `Element.scrollIntoView`, so only the options that method understands have an effect; anything else is ignored silently. */
    options?: ScrollIntoViewOptions;
  };
  /**
   * Finish the tour when the attached element leaves the viewport.
   * @default true
   */
  autoFinishByExit?: boolean;
  /** Hide individual tooltip buttons. */
  hideButtons?: {
    /** @default false */
    previous?: boolean;
    /**
     * Set per step by the component: hidden whenever `requireClick` is set, so anything given here is overwritten.
     * @default false
     */
    next?: boolean;
    /** @default false */
    exit?: boolean;
  };
  /** Labels for the tooltip buttons. */
  labels?: {
    previousButton?: string;
    nextButton?: string;
    finishButton?: string;
  };
  /**
   * Keep the tooltip hidden while an async `beforeStep` hook runs, instead of flashing it at the previous position. Set to `true` for every step by the component, so anything given here is overwritten.
   * @default false
   */
  hideNextStepDuringHook?: boolean;
}

/** The dimmed backdrop and the cut-out around the attached element. */
export interface SvgOverlayOptions {
  /** @default true */
  enabled?: boolean;
  /** Space between the attached element and the edge of the cut-out, in pixels. */
  padding?:
    | number
    | {
        top?: number;
        right?: number;
        bottom?: number;
        left?: number;
      };
  /** Corner radius of the cut-out, in pixels. */
  borderRadius?:
    | number
    | {
        leftTop?: number;
        rightTop?: number;
        rightBottom?: number;
        leftBottom?: number;
      };
  /**
   * Swallow clicks outside the tooltip. This tour sets it to `false` on the wrapper, because the steps talk the user through clicking the application itself; overriding it back to `true` on a step would also install a focus trap that cancels those clicks.
   * @default true
   */
  preventOverlayInteraction?: boolean;
}

/** Passed straight to `Element.scrollIntoView`, so only the options that method understands have an effect; anything else is ignored silently. */
export interface ScrollIntoViewOptions {
  /** @default "auto" */
  behavior?: "auto" | "instant" | "smooth";
  /**
   * Alignment along the block axis (vertical, in this application).
   * @default "start"
   */
  block?: "start" | "center" | "end" | "nearest";
  /**
   * Alignment along the inline axis (horizontal, in this application).
   * @default "nearest"
   */
  inline?: "start" | "center" | "end" | "nearest";
  /**
   * Defines the scrollable ancestor container.
   * @default "all"
   */
  container?: "all" | "nearest";
}

/**
 * Where the tooltip sits relative to the attached element. `auto*` picks the side with the most room.
 * @default "bottom"
 */
export enum PopperPlacement {
  Auto = "auto",
  AutoStart = "auto-start",
  AutoEnd = "auto-end",
  Top = "top",
  TopStart = "top-start",
  TopEnd = "top-end",
  Bottom = "bottom",
  BottomStart = "bottom-start",
  BottomEnd = "bottom-end",
  Right = "right",
  RightStart = "right-start",
  RightEnd = "right-end",
  Left = "left",
  LeftStart = "left-start",
  LeftEnd = "left-end",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://localhost:8984";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Current Vicav API
 * @version 1.0.0
 * @license MIT (https://opensource.org/licenses/MIT)
 * @baseUrl http://localhost:8984
 * @contact <christoph.hoffmann@oeaw.ac.at>
 *
 * This is the currently implemented vicav API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  vicav = {
    /**
     * @description Get info about the project, menus and open panels/windows
     *
     * @tags noauth
     * @name GetProject
     * @summary gets basic project configuration
     * @request GET:/vicav/project
     * @secure
     */
    getProject: (params: RequestParams = {}) =>
      this.request<ProjectConfig, RFC7807Problem>({
        path: `/vicav/project`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description -
     *
     * @tags noauth
     * @name CreateProjectConfigCache
     * @summary creates a cache with for the JSON returned for projectConfig
     * @request PUT:/vicav/project
     * @secure
     */
    createProjectConfigCache: (params: RequestParams = {}) =>
      this.request<ProjectConfig, any>({
        path: `/vicav/project`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description By passing the appropriate xml-ID and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetText
     * @summary gets a description text identtified by its tei:div@xml:id
     * @request GET:/vicav/text
     * @secure
     */
    getText: (
      query: {
        /** the @xml:id of the tei:div xml element */
        id: string;
        /** the filename of the xslt transformation (for development purposes only) */
        xslt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, RFC7807Problem>({
        path: `/vicav/text`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing the appropriate xml-ID and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetSampleText
     * @summary gets a linguistic sample text identtified by its tei:div@xml:id
     * @request GET:/vicav/sample
     * @secure
     */
    getSampleText: (
      query: {
        /** the @xml:id of the tei:div xml element */
        id: string;
        /** the filename of the xslt transformation (for development purposes only) */
        xslt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, RFC7807Problem>({
        path: `/vicav/sample`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing the appropriate xml-ID and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetProfile
     * @summary gets a langauge profile identified by its TEI@xml:id
     * @request GET:/vicav/profile
     * @secure
     */
    getProfile: (
      query: {
        /** the @xml:id of the TEI xml element */
        id: string;
        /** the id of the collection/database to use (for development purposes only) */
        coll?: string;
        /** the filename of the xslt transformation (for development purposes only) */
        xslt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, RFC7807Problem>({
        path: `/vicav/profile`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description no further description
     *
     * @tags noauth
     * @name GetLingFeature
     * @summary Get a standardized text showing lingusitic features of a variety
     * @request GET:/vicav/ling_feature
     * @secure
     */
    getLingFeature: (
      query?: {
        /** @example "ling_features_baghdad" */
        id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<string | null, RFC7807Problem>({
        path: `/vicav/ling_feature`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing the appropriate xml-ID and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetExploreSamples
     * @summary Search sample texts or feature lists by keyword or meatadata and return a rendered list of matching sentences.
     * @request GET:/vicav/explore_samples
     * @secure
     */
    getExploreSamples: (
      query: {
        /** collection to query eg. vicav_lingfeatures */
        type: string;
        /** the word to search for */
        word?: string;
        /** search by speaker */
        person?: string;
        /** only search specific features */
        features?: string;
        /** search in comment */
        comment?: string;
        /** only search in translation */
        translation?: string;
        /** the filename of the xslt transformation (for development purposes only) */
        xslt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, AttachableElement>({
        path: `/vicav/explore_samples`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing the appropriate xml-ID and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetCompare
     * @summary Search sample texts or feature lists by keyword or meatadata and return a rendered list of matching sentences.
     * @request GET:/vicav/compare
     * @secure
     */
    getCompare: (
      query: {
        /** collection to query eg. lingfeatures */
        type: string;
        /** the word to search for */
        word?: string;
        /** search by document ids */
        ids: string;
        /** only search specific features */
        features?: string;
        /** search in comment */
        comment?: string;
        /** only search specific features */
        translation?: string;
        /** only search specific features */
        page?: string;
        /** only search specific features */
        print?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, AttachableElement>({
        path: `/vicav/compare`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing the appropriate xml-ID and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetCompareMarkers
     * @summary Search sample texts or feature lists by keyword or meatadata and return a rendered list of matching sentences.
     * @request GET:/vicav/compare_markers
     * @secure
     */
    getCompareMarkers: (
      query: {
        /** collection to query eg. lingfeatures */
        type: string;
        /** the word to search for */
        word?: string;
        /** search by document ids */
        ids: string;
        /** only search specific features */
        features?: string;
        /** search in comment */
        comment?: string;
        /** only search specific features */
        translation?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<Feature[], AttachableElement>({
        path: `/vicav/compare_markers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A simple list of supported feature codes alog with their human-readable labels
     *
     * @tags noauth
     * @name GetFeatureLabels
     * @summary Feature labels and values.
     * @request GET:/vicav/feature_labels
     * @secure
     */
    getFeatureLabels: (params: RequestParams = {}) =>
      this.request<SearchTags, any>({
        path: `/vicav/feature_labels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A simple list of all distinct words in a database to be used as tag options in search form.
     *
     * @tags noauth
     * @name GetDataWords
     * @summary Get all distinct words in a given corpus.
     * @request GET:/vicav/data_words
     * @secure
     */
    getDataWords: (
      query?: {
        /** Database name not including vicav_ prefix */
        type?: string;
        /** Search words by this fragment */
        query?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ParamType, any>({
        path: `/vicav/data_words`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description By passing a well formed query and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetBiblioTei
     * @summary gets a specific html transformed via a specified xslt
     * @request GET:/vicav/biblio_tei
     * @secure
     */
    getBiblioTei: (
      query: {
        /** the query */
        query: string;
        /** the filename of the xslt transformation (for development purposes only) */
        xslt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, RFC7807Problem>({
        path: `/vicav/biblio_tei`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieve geo data information from the bibliography for displaying coordinates on a map.
     *
     * @tags noauth
     * @name GetMarkers
     * @summary gets a geo marker information
     * @request GET:/vicav/bibl_markers_tei
     * @secure
     */
    getMarkers: (
      query: {
        /**
         * A BaseX Full-Text search query in in vicav-biblio tei:biblstruct with wildcards enabled.
         * See: https://docs.basex.org/wiki/Full-Text#Match_Options
         * using wildcards using diacritics sensitive
         * Uses prefixes to limit the full text search to certein elements.
         * * date: -> tei:date
         * * title: -> tei:title
         * * pubPlace: -> tei:pubPlace
         * * author: -> tei:author/tei:surname
         * * geo:, geo_reg:, reg:, diaGroup: -> tei:note[@type="tag"]/tei:name
         * * vt:, prj: -> tei:note[@type="tag"]
         *
         * Without a prefix any text in vicav-biblio tei:biblstruct is searched.
         *
         * More than one query is possible by separating with ' '/+.
         */
        query: string;
        /**
         * Filters based on a set of tei:name/@types being present in a tei:note[tei:geo]
         * * geo
         * * diaGroup
         * * reg
         * * geo_reg: any of the above (deprecated, use this as an array)
         */
        scope: ("geo_reg" | "geo" | "reg" | "diaGroup")[];
      },
      params: RequestParams = {},
    ) =>
      this.request<Feature[], RFC7807Problem>({
        path: `/vicav/bibl_markers_tei`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description returns all bibliographic or geo data
     *
     * @tags noauth
     * @name GetDataLists
     * @summary get data lists in json or xml format
     * @request GET:/vicav/{dataType}_data
     * @secure
     */
    getDataLists: (
      dataType: "biblio" | "geo",
      query?: {
        /** default is json */
        render?: "json" | "xml" | "xml_for_parser";
      },
      params: RequestParams = {},
    ) =>
      this.request<Ref, RFC7807Problem>({
        path: `/vicav/${dataType}_data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description FeatureCollection of all coordinates in the gazetteer and the place XML data in properties
     *
     * @tags noauth
     * @name GetGeojsonGazetteer
     * @summary get the VICAV Gazetteer
     * @request GET:/vicav/geojson_gazetteer
     * @secure
     */
    getGeojsonGazetteer: (params: RequestParams = {}) =>
      this.request<FeatureCollection, any>({
        path: `/vicav/geojson_gazetteer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description I have no idea
     *
     * @tags noauth
     * @name GetGeoMarkers
     * @summary gets a specific xml
     * @request GET:/vicav/{name}_markers
     * @secure
     */
    getGeoMarkers: (name: MarkersType, params: RequestParams = {}) =>
      this.request<Feature[], RFC7807Problem>({
        path: `/vicav/${name}_markers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description By passing a well formed query and xslt you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetDictApi
     * @summary gets a specific html transformed via a specified xslt
     * @request GET:/vicav/dict_api
     * @secure
     */
    getDictApi: (
      query: {
        /** the query */
        query: string;
        /** the dict id? */
        dict: string;
        /** the filename of the xslt transformation (for development purposes only) */
        xslt?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, AttachableElement>({
        path: `/vicav/dict_api`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing a well formed query you can retrieve ready to display html
     *
     * @tags noauth
     * @name GetDictIndex
     * @summary gets a specific html transformed via a specified xslt
     * @request GET:/vicav/dict_index
     * @secure
     */
    getDictIndex: (
      query: {
        /** the dict id? */
        dict: string;
        /** I have no idea */
        ind: "any" | "lem" | "infl" | "en" | "de" | "fr" | "pos" | "root" | "subc" | "etymSrc" | "etymLang";
        /** the query string? */
        str: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AttachableElement, AttachableElement>({
        path: `/vicav/dict_index`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description By passing a well formed noSKE query as 'query' parameter, you can retrieve serach results
     *
     * @tags noauth
     * @name SearchCorpus
     * @summary Search corpus
     * @request GET:/vicav/corpus
     * @secure
     */
    searchCorpus: (
      query: {
        /** query to perform against NoSKE */
        query: string;
        /**
         * page of the result
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * number of results per page
         * @min 0
         * @max 100
         * @default 100
         */
        pageSize?: number;
        /** Render the results as html or json. Default is html */
        render?: "html" | "json";
        /** Whether to retrieve a full HTML file with printer-friendly formatting. */
        print?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CorpusSearchHTML | CorpusSearch, RFC7807Problem>({
        path: `/vicav/corpus`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description A pageable set of corpus utterances from the given text.
     *
     * @tags noauth
     * @name GetCorpusText
     * @summary Get rendered corpus text
     * @request GET:/vicav/corpus_text
     * @secure
     */
    getCorpusText: (
      query: {
        /** Corpus text ID */
        id: string;
        /**
         * How many results to retrieve in one query. Defaults to 10.
         * @default 10
         */
        size?: number;
        /**
         * Page number to retrieve. Defaults to 1.
         * @default 1
         */
        page?: number;
        /** Comma-separated token IDs to highlight */
        hits?: string;
        /** Render the results as html or json. Default is html */
        render?: "html" | "json";
        /** Whether to retrieve a full HTML file with printer-friendly formatting. */
        print?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CorpusText | CorpusTextHTML, RFC7807Problem>({
        path: `/vicav/corpus_text`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  restvle = {
    /**
     * @description -
     *
     * @tags vleserver-api
     * @name GetRestVleurls
     * @summary A static collection showing valid next URLs.
     * @request GET:/restvle
     * @secure
     */
    getRestVleurls: (params: RequestParams = {}) =>
      this.request<RestVLEURIs, RFC7807Problem>({
        path: `/restvle`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description -
     *
     * @tags vleserver-api
     * @name GetDicts
     * @summary A list of all dictionaries available on this server.
     * @request GET:/restvle/dicts
     * @secure
     */
    getDicts: (
      query?: {
        /**
         * The page page to return based on the given pageSize
         * @example "1"
         */
        page?: any;
        /**
         * Number of entries to return per request
         * @example "10"
         */
        pageSize?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<RestVLEDicts, RFC7807Problem>({
        path: `/restvle/dicts`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Here you find pointers to the next endpoints you can use and also some information about the queries you can use.
     *
     * @tags vleserver-api
     * @name GetDictDictName
     * @summary Info about the dictionary.
     * @request GET:/restvle/dicts/{dict_name}
     * @secure
     */
    getDictDictName: (dictName: any, params: RequestParams = {}) =>
      this.request<RestVLEDictInfo, RFC7807Problem>({
        path: `/restvle/dicts/${dictName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description JSON data that can be used for auto complete help for dictionary search.
     *
     * @tags vleserver-api
     * @name GetDictDictNameAutocomplete
     * @summary Returns a JSON describing all possible words that can be found with queries for auto complete help.
     * @request GET:/restvle/dicts/{dict_name}/autocomplete
     * @secure
     */
    getDictDictNameAutocomplete: (dictName: any, params: RequestParams = {}) =>
      this.request<AutoCompleteData, RFC7807Problem>({
        path: `/restvle/dicts/${dictName}/autocomplete`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description There seems to be a limit of about 80 ids that can be specified at any one time. This will be the URI to search for a particular entry by numerous filter an search options. Search option are defined as queryTemplates in profiles. They can be used as name=value query parameters.
     *
     * @tags vleserver-api
     * @name GetDictDictNameEntries
     * @summary A list of all entries for a particular dictionary. TODO: Limit by query.
     * @request GET:/restvle/dicts/{dict_name}/entries
     * @secure
     */
    getDictDictNameEntries: (
      dictName: any,
      query?: {
        /**
         * The page page to return based on the given pageSize
         * @example 1
         */
        page?: number | null;
        /**
         * Number of entries to return per request
         * @example 10
         */
        pageSize?: number | null;
        /**
         * Filter by ids starting with this string
         * @example "il_"
         */
        id?: string | null;
        /**
         * Return entries matching exactly the ids provided as a comma separated list
         * @example "il_mafruud_001"
         */
        ids?: string | null;
        /**
         * A name of a query template stored in the profile.
         * @example "ft_all=mafru.*"
         */
        q?: string | null;
        /** One of "asc", "desc" or "none" */
        sort?: "asc" | "desc" | "none" | null;
        /**
         * A name of an alternative lemma definition to use (specified in profile)
         * @example ""
         */
        altLemma?: string | null;
        /**
         * An XML format the TEI should be transformed to (e. g. html)
         * Only authenticated users.
         * @example "html"
         */
        format?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<RestVLEEntries, RFC7807Problem>({
        path: `/restvle/dicts/${dictName}/entries`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description -
     *
     * @tags vleserver-api
     * @name GetDictDictNameEntry
     * @summary Get a particular entry from a dictionary.
     * @request GET:/restvle/dicts/{dict_name}/entries/{id}
     * @secure
     */
    getDictDictNameEntry: (
      dictName: any,
      id: any,
      query?: {
        /** @example "" */
        format?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<RestVLEEntry, RFC7807Problem>({
        path: `/restvle/dicts/${dictName}/entries/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
